/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PerformerContractStatus {
    Draft = 'draft',
    Pending = 'pending',
    Sent = 'sent',
    PerformerSigned = 'performer_signed',
    ProducerSigned = 'producer_signed',
    Completed = 'completed',
    TimeLogApproved = 'time_log_approved',
    Cancelled = 'cancelled',
    Declined = 'declined',
}
